import type { AssetId, IndicationId, KiqId } from '@/types'

export const OTHER_TAXONOMY_ID = 'other'
const ENABLED_FLAG_VALUES = new Set(['1', 'true', 'yes'])

interface TaxonomySelectionInput {
  assetId?: AssetId | null
  indicationId?: IndicationId | null
  kiqIds?: KiqId[] | null
}

export interface NormalizedTaxonomySelection {
  assetId: AssetId
  indicationId: IndicationId
  kiqIds: KiqId[]
}

export function isOptionalTaxonomyFallbackEnabled(): boolean {
  const rawValue = import.meta.env.VITE_OPTIONAL_TAXONOMY_FALLBACK?.toLowerCase()
  return rawValue ? ENABLED_FLAG_VALUES.has(rawValue) : false
}

function hasCompleteTaxonomySelection(
  selection: TaxonomySelectionInput,
): selection is NormalizedTaxonomySelection {
  return Boolean(
    selection.assetId &&
      selection.indicationId &&
      Array.isArray(selection.kiqIds) &&
      selection.kiqIds.length > 0,
  )
}

export function normalizeTaxonomySelection(
  selection: TaxonomySelectionInput,
): NormalizedTaxonomySelection {
  if (hasCompleteTaxonomySelection(selection)) {
    return {
      assetId: selection.assetId,
      indicationId: selection.indicationId,
      kiqIds: selection.kiqIds,
    }
  }

  if (!isOptionalTaxonomyFallbackEnabled()) {
    throw new Error('Taxonomy selection is incomplete')
  }

  return {
    assetId: selection.assetId || OTHER_TAXONOMY_ID,
    indicationId: selection.indicationId || OTHER_TAXONOMY_ID,
    kiqIds: selection.kiqIds?.length ? selection.kiqIds : [OTHER_TAXONOMY_ID],
  }
}

export function isOtherTaxonomyId(value?: string | null): boolean {
  return value === OTHER_TAXONOMY_ID
}
